import React from 'react';
import {COLORS} from '../../../../../constants/colors';
import {Icon} from '../../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../../atoms/Icon/IconName';
import {BasicControl} from './BasicControl';

export const MuteControl: React.FC<{
  muteFunction: () => void;
}> = ({muteFunction}) => {
  return (
    <BasicControl onClick={muteFunction}>
      <Icon
        asset={GenericIconName.Unmute}
        width={20}
        height={20}
        fillOpacity={0.6}
        strokeWidth={2}
        fill={COLORS.White}
      />
    </BasicControl>
  );
};
